import './App.css';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import { getOffice, isLogin } from './authorization/auth';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { blue } from '@mui/material/colors';

function App() {
  const navigate = useNavigate();
  let nextPage = null;

  if (getOffice() == null) {
    nextPage = "/login";
  } else if (isLogin() === false) {
    nextPage = "/login/" + getOffice();
  } else {
    nextPage = "/dashboard"
  }

  useEffect(() => {
    if (nextPage !== null) {
      const timeout = setTimeout(() => navigate(nextPage), 100);
      return () => clearTimeout(timeout);
    }
  }, [navigate, nextPage]);

  return (
    <Backdrop
      sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, background: blue[500] })}
      open={true}
    >
      <CircularProgress color="inherit" />
      <Typography variant='h4' ml={5}>Courier CRM</Typography>
    </Backdrop>

  );
}

export default App;
